import { EmptyStatesType } from "common/Icons/types.ts";
import EmptyView from "common/Empty/EmptyView.tsx";
import React, { useContext } from "react";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context.ts";

const EmptySymbols = () => {
  const { searchValue, setShowOnlyModifiedSymbols } = useContext(
    MultiSymbolMarginContext
  )!;

  return (
    <EmptyView
      iconKey={EmptyStatesType.Empty}
      iconWidth={100}
      title="No symbols with custom settings found"
      description="Click the button below to show all symbols"
      isSearch={!!searchValue}
      buttonText="Show all symbols"
      buttonOnClick={() => setShowOnlyModifiedSymbols(false)}
    />
  );
};

export default EmptySymbols;
